import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Coordinates } from '../models/coordinates.model';
import { Observable } from 'rxjs';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private pathApi: string;
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'dashboard/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getDefaultCoordinates(obj: any) {
    return this.http.post<Coordinates>(
      `${this.pathApi}getDefaultCoordinates`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }
  getAnalyticsOverviewBuilding(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getV3AnalyticsOverviewBuildings`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }
  getAnalyticsOverviewCustomer(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getV3AnalyticsOverviewCustomer`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }
  getAnalyticsOverviewDt(obj: any) {
    return this.http.post<any>(`${this.pathApi}getAnalyticsOverviewDt`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
  getAnalyticsOverviewPole(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getV3AnalyticsOverviewPole`,
      obj,
      {
        headers: this.headers,
        observe: 'response',
      }
    );
  }
  getAnalyticsOverviewLvPole(obj: any) {
    return this.http.post<any>(`${this.pathApi}getAnalyticsOverviewPole`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
  getAnalyticsOverviewTs(obj: any) {
    return this.http.post<any>(`${this.pathApi}getAnalyticsOverviewTs`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
  getAnalyticsOverviewSubstation(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getAnalyticsOverviewSubstation`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }
  getAnalyticsOverviewSectionDefinition(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getAnalyticsOverviewSectionDefinition`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }
  getAnalyticsOverviewF11(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getAnalyticsOverviewFeeder11`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }
  getAnalyticsOverviewF33(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getAnalyticsOverviewFeeder33`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }
  getAnalyticsOverviewMvPole(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getAnalyticsOverviewMvPole`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }

  getOperationsAnalytics(obj: any) {
    return this.http.post<any>(`${this.pathApi}getOperationsAnalytics`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getPoleDashboardBreakdownData(obj: any) {
    return this.http.post<any>(
      `${this.pathApi}getPoleDashboardBreakdownData`,
      obj,
      {
        headers: this.headers,
        observe: 'response',
      }
    );
  }

  getAssetsCounts(areaIds: number[]) {
    return this.http.post<any>(`${this.pathApi}getAssetsCounts`, areaIds, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getGraphData(request: any) {
    let param = JSON.stringify(request);
    return this.http.post<any>(`${this.pathApi}getGraphData`, param, {
      headers: this.headers,
      observe: 'response',
    });
  }
  getNetworkAssetOptions(option: number) {
    return this.http.get<any>(
      `${this.pathApi}getNetworkAssetOptions/${option}`,
      { headers: this.headers, observe: 'response' }
    );
  }

  getDashboardMeterValidation(
    utilityId: number | null = null
  ): Observable<any> {
    return this.http.get(
      `${this.pathApi}getDashboardValidationMeters?utilityId=${utilityId}`,
      { headers: this.headers, observe: 'response' }
    );
  }
}
